import { useMutation, useQueryClient } from '@common-fe/common-fe';
import dayjs from 'dayjs';

import { api } from '@/api';
import { DEFAULT_DATE_FORMAT, RAW_DATE_FORMAT } from '@/common/constants';
import { API_URL } from '@/dtos';

import { CreateAuthorizedUserParams } from '../authorizedUsers.types';

const postAuthorizedUser = (params: CreateAuthorizedUserParams, employeeId: number) =>
  api.post(API_URL.AUTHORIZED_USERS, {
    employee_id: employeeId,
    first_name: params.firstName,
    last_name: params.lastName,
    relationship_type: params.relationshipType,
    birth_on: dayjs(params.birthOn, DEFAULT_DATE_FORMAT).format(RAW_DATE_FORMAT),
  });

const useCreateAuthorizedUserQuery = (employeeId?: string, onSuccess?: () => void) => {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation(
    (params: CreateAuthorizedUserParams) => postAuthorizedUser(params, Number(employeeId)),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [API_URL.EMPLOYEES_AUTHORIZED_USERS_BY_EMPLOYEE_ID('')],
        });
        if (onSuccess) onSuccess();
      },
    }
  );

  return {
    createAuthorizedUser: mutateAsync,
    isPending,
  };
};

export default useCreateAuthorizedUserQuery;
